<template>
  <div>
    <v-dialog v-model="ModalEdit" persistent max-width="50%">
      <v-card>
        <v-card-title> Edit Data </v-card-title>

        <v-divider class="mt-2 mb-5"></v-divider>

        <v-card-text>
          <v-form ref="form">
            <v-row dense>
              <v-col cols="12" md="12">
                <v-textarea
                  v-model="SData.ket"
                  label="Ikhtisar Jabatan"
                  outlined
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mt-n5"></v-divider>

        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="gray" @click="closeModal()"> Batal </v-btn>

          <v-btn color="primary" @click="add()" v-if="LBtn"> Simpan </v-btn>
          <v-btn color="primary" loading v-else> Simpan </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Cookie from "@/helper/cookie.js";

import SEdit from "@/store/anjab/infojabatan/ikhtisarjab/edit";
import SView from "@/store/anjab/infojabatan/ikhtisarjab/view";

export default {
  computed: {
    ModalEdit: {
      get() {
        return SEdit.state.ModalEdit;
      },
      set(value) {
        SEdit.commit("TModal", value);
      },
    },

    SData: {
      get() {
        return SEdit.state.data;
      },

      set(value) {
        console.log(value);
      },
    },
  },

  watch: {
    async ModalEdit() {},
  },

  data: () => ({
    token: Cookie.get("token"),
    LBtn: true,
  }),

  methods: {
    reset() {
      this.$refs.form.reset();
    },

    async add() {
      this.LBtn = false;

      let data = {
        ikhtisar_id:  this.SData.id,
        jab_id:  this.$route.params.id,
        ikhtisar_ket: this.SData.ket,
      };

      const url = `${process.env.VUE_APP_API}/ikhtisar/edit`;

      this.axios
        .put(url, data, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.LBtn = true;
          if (res.data.success) {
            SView.commit("refreshData", true);
            SView.commit("alert", res.data.message);
            SView.commit("berhasilAlert", true);
            SView.commit("gagalAlert", false);
            SView.commit("success", res.data.success);
          } else {
            SView.commit("refreshData", true);
            SView.commit("alert", res.data.message);
            SView.commit("gagalAlert", true);
            SView.commit("berhasilAlert", false);
            SView.commit("success", res.data.success);
          }

          this.closeModal();
        })
        .catch((error) => {
          SView.commit("refreshData", true);
          SView.commit("alert", error.response.data.message);
          SView.commit("gagalAlert", true);
          SView.commit("berhasilAlert", false);
          SView.commit("success", error.response.data.success);
          console.log(error.response.status);
          console.log("Error", error.message);
          this.LBtn = true;

          this.closeModal();
        });
    },

    async closeModal() {
      await SView.commit("refreshData", true);
      this.reset();
      this.ModalEdit = false;
    },
  },
};
</script>
